/**
 * Utility to reset the test module announcement for testing purposes
 * Call this from browser console: resetTestAnnouncement()
 */
export const resetTestAnnouncement = () => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('test-module-announcement-seen-')) {
      localStorage.removeItem(key);
    }
  });
  console.log('Test module announcement reset. Refresh the page to see it again.');
};

// Make it available globally for console access
if (typeof window !== 'undefined') {
  (window as any).resetTestAnnouncement = resetTestAnnouncement;
}
